import React from 'react';
import PropTypes from 'prop-types';
import {
  CELSIUS_ID,
  FAHRENHEIT_ID,
  SPEED_FEET,
  SPEED_METERS,
} from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelValueRender';
import AlertRowLastReadingBadge
  from '../../../../alerts/AlertListLayout/AlertListTable/AlertListTableRow/AlertRowLastReadingBadge/AlertRowLastReadingBadge';
import getChannelValueWithUnitsFromChannelKeyObjectString
  from '../../../../common/ChannelValueWithUnitsFromChannelKeyObject/getChannelValueWithUnitsFromChannelKeyObjectString';

const cellStyle = {
  maxWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const getCellTitle = (alert, channelKeyObject, customScales) => {
  if (alert.isSuspended) {
    return 'Alert Suspended';
  }
  if (alert.isDeviceSuspended) {
    return 'Device Suspended';
  }
  return getChannelValueWithUnitsFromChannelKeyObjectString(
    customScales,
    channelKeyObject,
    alert.lastSampleValue,
    alert.customUnit,
  );
};

const LatestReadingCell = ({
  alert, channelKeyObject, isTriggered, userPreferences,
}) => (
  <td
    className="align-middle"
    style={cellStyle}
    title={getCellTitle(alert, channelKeyObject, userPreferences)}
  >
    <AlertRowLastReadingBadge
      isSuspended={alert.isSuspended}
      isDeviceSuspended={alert.isDeviceSuspended}
      lastReading={alert.lastSampleValue}
      lastReadingTimestamp={alert.lastSampleTimestamp}
      isTriggered={isTriggered}
      triggeredTimestamp={alert.triggeredTimestamp}
      isAcknowledged={alert.acknowledgementTimestamp !== null}
      channelKeyObj={channelKeyObject}
      customUnit={alert.customUnit}
      customScales={userPreferences}
    />
  </td>
);

LatestReadingCell.propTypes = {
  alert: PropTypes.shape({
    isSuspended: PropTypes.bool,
    isDeviceSuspended: PropTypes.bool,
    lastSampleValue: PropTypes.string,
    lastSampleTimestamp: PropTypes.number,
    triggeredTimestamp: PropTypes.number,
    acknowledgementTimestamp: PropTypes.number,
    customUnit: PropTypes.string,
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  channelKeyObject: PropTypes.object.isRequired,
  isTriggered: PropTypes.bool.isRequired,
  userPreferences: PropTypes.shape({
    temperatureScale: PropTypes.oneOf([CELSIUS_ID, FAHRENHEIT_ID]),
    airSpeedScale: PropTypes.oneOf([SPEED_METERS, SPEED_FEET]),
  }),
};

LatestReadingCell.defaultProps = {
  userPreferences: {
    temperatureScale: CELSIUS_ID,
    airSpeedScale: SPEED_METERS,
  },
};

export default LatestReadingCell;
